const p = "_wrapper_102mi_1", r = {
  wrapper: p
};
export {
  r as default,
  p as wrapper
};
